export enum ClassType {
    CurrencyInTable = "currency-in-table",
    CurrencyInTableSummary = "currency-in-table-summary"
}
